import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouter } from '@tanstack/react-router';
import { Plus } from 'lucide-react';

import { useCreateThread, useMyThreads } from '@/api/generated';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

const ThreadList = () => {
  const { t } = useTranslation();
  const { data, refetch } = useMyThreads();
  const router = useRouter();
  const { mutateAsync: createThread } = useCreateThread();

  const handleCreateThread = useCallback(async () => {
    createThread(undefined, {
      onSuccess: async (result) => {
        await router.navigate({
          to: `/app/threads/${result.id}`,
        });
      },
      onSettled: () => {
        refetch();
      },
    });
  }, [createThread, refetch, router]);

  return (
    <Card className='max-h-[70vh] overflow-y-auto'>
      <CardHeader>
        <CardTitle>{t('threads.threadList.title')}</CardTitle>
        <CardAction>
          <Button
            variant={'outline'}
            onClick={handleCreateThread}>
            <Button.Icon icon>
              <Plus />
            </Button.Icon>
          </Button>
        </CardAction>
      </CardHeader>
      <CardContent>
        <div className='flex flex-col gap-4'>
          {data?.map((thread, i) => (
            <>
              <Link
                key={thread.id}
                to={`/app/threads/$threadId`}
                params={{
                  threadId: thread.id,
                }}>
                {thread.title}
              </Link>
              {i !== data.length - 1 && <Separator />}
            </>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ThreadList;
